<template>
  <div class="wrap">
    <img class="wrapBgc" src="https://p1.ssl.qhimg.com/t01c4c4c5f00f1cbc3f.png" />
    <div class="wrapNav">
      <p class="wrapNavTitle clear">最新活动</p>
      <p class="wrapNavDesc clear">RECENT ACTIVITIES</p>
      <div class="wrapNavActive">
        <img class="wrapNavActiveImg" :src="nav.pic" alt="图片介绍" @click="toMore(nav.moreUrl)" />
        <Btn :navArr="IscActive_2023" :pitchId="id" :style="styleBtn" @fetchNav="fetchNav" />
      </div>
    </div>
    <div
      v-for="item in IscActive_2023"
      :key="item.id"
      class="wrapDesc animate__animated animate__slideInRight"
      :class="item.id === id ? 'block ' : 'hidden'"
      @click="toMore(nav.moreUrl)"
    >
      <p class="wrapDescNum clear">0{{ item.id + 1 }}</p>
      <p class="wrapDescTitle clear">{{ nav.desc_title }}</p>
    </div>
  </div>
</template>

<script setup>
import { IscActive_2023 } from '@/mock/2023isc/data.js'
import { ref } from 'vue'
import Btn from '@/components/common/2023/button.vue'
const id = ref(0)
const nav = ref(IscActive_2023[id.value])
const styleBtn = {
  position: 'absolute',
  right: '1px',
  top: '337px'
}
function fetchNav(newId) {
  id.value = newId
  nav.value = IscActive_2023[newId]
}
function toMore(url) {
  window.open(url)
}
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.block {
  display: block;
}
.hidden {
  display: none;
}
.wrap {
  position: relative;
  width: 100%;
  background-size: cover;
  padding: 20px 16px 40px;
  background-color: #fff;
  &Bgc {
    position: absolute;
    top: -47px;
    right: 0;
    width: 237px;
    height: 140px;
  }
  &Nav {
    margin: 0 auto;
    height: 450px;
    &Active {
      position: relative;
      &Img {
        width: 100%;
        // height: 200px;
      }
    }
    &Title {
      font-size: 18px;
      font-weight: bold;
      line-height: 28px;
      color: #00ab7a;
    }
    &Desc {
      font-size: 12px;
      line-height: 20px;
      color: #3d3d3d;
      margin-bottom: 20px;
    }
  }
  &Desc {
    position: absolute;
    right: 0px;
    top: 275px;
    // width: 398px;
    width: 100%;
    height: 130px;
    background: rgba(0, 171, 122, 0.96);
    color: #ffffff;
    padding: 8px 0 0 25px;
    border-radius: 40px 0 0;
    &Title {
      font-size: 16px;
      line-height: 20px;
      color: #ffffff;
      font-weight: bold;
    }
    &Num {
      width: 60px;
      height: 70px;
      font-size: 50px;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.78);
    }
  }
}
</style>
